import React, { createContext, useContext } from 'react'
import { ColumnTypePicker } from './useColumnTypePicker'

const ColumnTypePickerContext = createContext<ColumnTypePicker | null>(null)

export const ColumnTypePickerProvider: React.FC<{ picker: ColumnTypePicker; children: React.ReactNode }> = ({
  picker,
  children
}) => {
  'use no memo'
  return <ColumnTypePickerContext.Provider value={picker}>{children}</ColumnTypePickerContext.Provider>
}

// Read the picker provided by the nearest ColumnTypePickerProvider. Throws if used outside one, which is
// always a programming error (the add-column components are only ever rendered inside the menu).
export const usePicker = (): ColumnTypePicker => {
  const picker = useContext(ColumnTypePickerContext)
  if (!picker) throw new Error('usePicker must be used within a ColumnTypePickerProvider')
  return picker
}
